var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D3DCEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6496 7.52539C8.6496 6.90407 9.15327 6.40039 9.7746 6.40039H15.0246C15.6459 6.40039 16.1496 6.90407 16.1496 7.52539V7.90039H16.5246C17.5601 7.90039 18.3996 8.73986 18.3996 9.77539V13.5254C18.3996 14.1467 17.8959 14.6504 17.2746 14.6504H16.1496V15.7754C16.1496 16.3967 15.6459 16.9004 15.0246 16.9004H9.7746C9.15327 16.9004 8.6496 16.3967 8.6496 15.7754V14.6504H7.5246C6.90327 14.6504 6.3996 14.1467 6.3996 13.5254V9.77539C6.3996 8.73986 7.23906 7.90039 8.2746 7.90039H8.6496V7.52539ZM9.3996 7.90039H15.3996V7.52539C15.3996 7.31829 15.2317 7.15039 15.0246 7.15039H9.7746C9.56749 7.15039 9.3996 7.31829 9.3996 7.52539V7.90039ZM8.6496 13.9004V12.7754C8.6496 12.1541 9.15327 11.6504 9.7746 11.6504H15.0246C15.6459 11.6504 16.1496 12.1541 16.1496 12.7754V13.9004H17.2746C17.4817 13.9004 17.6496 13.7325 17.6496 13.5254V9.77539C17.6496 9.15407 17.1459 8.65039 16.5246 8.65039H8.2746C7.65327 8.65039 7.1496 9.15407 7.1496 9.77539V13.5254C7.1496 13.7325 7.31749 13.9004 7.5246 13.9004H8.6496ZM9.7746 12.4004C9.56749 12.4004 9.3996 12.5683 9.3996 12.7754V15.7754C9.3996 15.9825 9.56749 16.1504 9.7746 16.1504H15.0246C15.2317 16.1504 15.3996 15.9825 15.3996 15.7754V12.7754C15.3996 12.5683 15.2317 12.4004 15.0246 12.4004H9.7746Z",
    fill: "#7C8092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.9dad614350407c4c404661183a21838a.svg";
export { ForwardRef as ReactComponent };